<template>
  <div class="content">
    <el-form :label-position="labelPosition" label-width="180px" :model="formInfo" ref="formInfo" :rules="rules"
             v-loading="loading"
             element-loading-text="The input data is being submitted, please wait……">
      <el-form-item label="1. Select desired properties  for your generation"
                    :rules="{required:true, trigger:['blur']}">
<!--        <el-radio v-model="radio" label="1">-->
<!--          <div style="display: inline-block; vertical-align: middle">-->
<!--            <el-upload-->
<!--                class="upload-demo"-->
<!--                :on-preview="handlePreview"-->
<!--                :on-remove="handleRemove"-->
<!--                action=""-->
<!--                style="text-align: center;"-->
<!--                :http-request="httpRequest"-->
<!--                :before-remove="beforeRemove"-->
<!--                :multiple="false"-->
<!--                :limit="1"-->
<!--                :on-exceed="handleExceed"-->
<!--                :file-list="formInfo.fileList">-->
<!--              <el-button type="primary">Click to upload</el-button>-->
<!--            </el-upload>-->
<!--          </div>-->

<!--        </el-radio>-->
        <el-radio v-model="radio" label="2">
          <el-row style="display: inline-block; vertical-align: middle" :gutter="30">
            <el-col :span="12">
              <div class="grid-content">
                <div class="grid-content">
                  <el-form-item label="Molecular Weight">
                    <el-col :span="11">
                      <el-form-item>
                        <el-input v-model="formInfo.properties.molecularWeight.min"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col class="line" :span="2">-</el-col>
                    <el-col :span="11">
                      <el-form-item>
                        <el-input v-model="formInfo.properties.molecularWeight.max"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="QED">
                    <el-col :span="11">
                      <el-form-item>
                        <el-input v-model="formInfo.properties.QED.min"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col class="line" :span="2">-</el-col>
                    <el-col :span="11">
                      <el-form-item>
                        <el-input v-model="formInfo.properties.QED.max"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="HBA">
                    <el-col :span="11">
                      <el-form-item>
                        <el-input v-model="formInfo.properties.HBA.min"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col class="line" :span="2">-</el-col>
                    <el-col :span="11">
                      <el-form-item>
                        <el-input v-model="formInfo.properties.HBA.max"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-form-item>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content">
                <el-form-item label="logP">
                  <el-col :span="11">
                    <el-form-item>
                      <el-input v-model="formInfo.properties.logP.min"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-form-item>
                      <el-input v-model="formInfo.properties.logP.max"></el-input>
                    </el-form-item>
                  </el-col>
                </el-form-item>
                <el-form-item label="TPSA">
                  <el-col :span="11">
                    <el-form-item>
                      <el-input v-model="formInfo.properties.TPSA.min"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-form-item>
                      <el-input v-model="formInfo.properties.TPSA.max"></el-input>
                    </el-form-item>
                  </el-col>
                </el-form-item>
                <el-form-item label="HBD">
                  <el-col :span="11">
                    <el-form-item>
                      <el-input v-model="formInfo.properties.HBD.min"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-form-item>
                      <el-input v-model="formInfo.properties.HBD.max"></el-input>
                    </el-form-item>
                  </el-col>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-radio>
      </el-form-item>
      <el-form-item label="2. Enter the number of molecules you want to generate(optional, max = 100)."
                    prop="moleculesNumber"
      >
        <el-input v-model.number="formInfo.moleculesNumber"></el-input>
      </el-form-item>
      <el-form-item label="3. Please leave your email address and we will send the generated results to your email."
                    prop="email"

      >
        <el-input v-model="formInfo.email"></el-input>
        <span style="font-size: 12px; color: #909399; line-height: 1.5; display: block; margin-top: 4px;">
          Your uploaded data are used only for this task and are not shared or used for any other purpose. They are temporarily stored on our private server for up to six months.
        </span>
      </el-form-item>
      <el-form-item class="submit">
        <el-button type="primary" @click="submitForm">Submit</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  var sid=""
export default {
  name: "PropertyBasedForm",
  data() {

    return {
      loading:false,
      sid:sid,
      radio: '2',
      labelPosition: 'top',
      formInfo: {
        fileList: [],
        properties: {
          molecularWeight: {
            min: 300,
            max: 500
          },
          QED: {
            min: 0.4,
            max: 1.0
          },
          HBA: {
            min: 0,
            max: 10
          },
          logP: {
            min: 0,
            max: 5
          },
          TPSA: {
            min: 0,
            max: 140
          },
          HBD: {
            min: 0,
            max: 5
          }
        },
        moleculesNumber: 20,
        email: ''
      },
      rules: {
        moleculesNumber: [
          // {message: 'The number of molecules cannot be empty'},
          {type: 'number', min:0,max:100,message: 'The number of molecules should be numerical.Range: 0~100.'}
        ],
        email: [
          {message: 'Please input the email address.', trigger: 'blur'},
          {type: 'email', message: 'Please input the correct email address', trigger: ['blur', 'change']}
        ],
      }
    };
  },
  methods: {
    handleRemove(file, fileList) {
      this.formInfo.fileList.pop();
      console.log(fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`The current limit is 1 file selected`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`Confirmed to remove ${file.name}?`);
    },
    httpRequest(param) {
      console.log(param);
      this.formInfo.fileList.push(param.file);
    },
    submitForm() {

      const formData = new FormData();
      if (this.radio == '1') {
        if (this.formInfo.fileList.length == 0) {
          this.$alert('Please upload file.');
          return;
        }
        formData.append('file', this.formInfo.fileList[0], this.formInfo.fileList[0].name);
      } else {
        for (let [key, value] of Object.entries(this.formInfo.properties)) {
          console.log(value.min, value.max,key)
          console.log(value.min.constructor===String, value.max.constructor===String)

          // if (value.min.constructor===String|| value.max.constructor===String) {
          //   this.$alert('Please input the correct number.');
          //   return;
          // }
          if (value.min>value.max)
          {
            this.$alert('Please enter the correct minimum and maximum values.');
            return;
          }

          formData.append(key, value.min + '-' + value.max);
          formData.append("file", new File([''], 'nofile.txt'));
        }
      }
      this.$refs['formInfo'].validate((valid) => {
        if (valid) {
          this.loading=true

          sid = require('uuid').v1()//生成uuid

          console.log('submit');
          formData.append("moleculesNumber", this.formInfo.moleculesNumber);
          if(this.formInfo.email=='')
          {
            this.formInfo.email="2659381657@qq.com"
          }
          formData.append("email", this.formInfo.email);
          formData.append("uid", sid);
          // TODO: change the url
          axios.post("/generation/property", formData).then(res => {
            this.loading=false
            console.log(res.data);
            var that=this
            if (res.data.code === 403) {
              console.log(this.$alert)
              this.$alert(res.data.msg,"Tips",{
                confirmButtonText: 'Ok',
                callback:action => {
                  that.$router.push({
                    path:'/generation/success',
                    query:{
                      sid:sid
                    }
                  })
                }
              });
              return false;
            }
            else
            {
              this.$router.push({
                path:'/generation/success',
                query:{
                  sid:sid
                }
              })
            }
          }).catch(err => {
            this.loading=false
            console.log(err);
            this.$alert('error submit!!');
            return false;
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.el-form-item {
  text-align: left;
}


.submit {
  text-align: center;
}

.grid-content {
  display: inline-block;
}

.line {
  text-align: center;
}
.content{
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  background-color: RGB(255,255,255);
  border-radius: 10px;
  padding: 10px;
}

</style>
